module.exports = __webpack_public_path__ + "media/images/sarapoint/bg-51e94337cdeeab3cf1f31f54c0759755.svg";